export const careerRecommendations = {
  D: [
    "Geschäftsführer/CEO",
    "Vertriebsleiter",
    "Projektmanager",
    "Unternehmer",
    "Teamleiter",
    "Verkaufsmanager",
    "Berater",
    "Immobilienmakler",
    "Rechtsanwalt",
    "Chirurg"
  ],
  I: [
    "Verkäufer",
    "Marketing-Manager",
    "PR-Spezialist",
    "Trainer/Coach",
    "Personalberater",
    "Event-Manager",
    "Journalist",
    "Moderator",
    "Sozialarbeiter",
    "Lehrer"
  ],
  S: [
    "Krankenpfleger",
    "Sozialarbeiter",
    "Kundendienst",
    "Therapeut",
    "Personalreferent",
    "Sekretär/Assistent",
    "Bibliothekar",
    "Berater",
    "Physiotherapeut",
    "Erzieher"
  ],
  C: [
    "Buchhalter",
    "Wirtschaftsprüfer",
    "Ingenieur",
    "Qualitätskontrolleur",
    "Forscher",
    "Analyst",
    "Programmierer",
    "Architekt",
    "Statistiker",
    "Laborant"
  ]
};

export function generateCareerRecommendations(scores) {
  const sortedTypes = Object.entries(scores)
    .sort(([,a], [,b]) => b - a)
    .map(([type]) => type);

  const recommendations = new Set();
  
  // Add careers based on dominant types
  sortedTypes.forEach((type, index) => {
    const weight = 4 - index; // Higher weight for dominant types
    const careers = careerRecommendations[type];
    
    for (let i = 0; i < Math.min(weight * 3, careers.length); i++) {
      recommendations.add(careers[i]);
    }
  });

  return Array.from(recommendations).slice(0, 10);
}